import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import {
    BUTTON_SIZE_LARGE,
    BUTTON_SIZE_MEDIUM,
    BUTTON_SIZE_SMALL,
    BUTTON_SIZES,
    BUTTON_THEME_DEFAULT,
    BUTTON_THEMES,
    ButtonThemesStyles,
    ICON_BUTTON_THEMES
} from '../Button/themes';

interface StyledButtonProps {
    disabled?: boolean;
    onClick?: () => void;
    size?: number | null;
    theme: {
        background: string;
        border: string;
        hover: {
            background: string;
            border: string;
            icon: string;
            text: string;
        };
        icon: string;
        text: string;
    };
}

const StButton = styled.button<StyledButtonProps>`
    display: flex;
    color: ${props => props.theme.text};
    border-style: solid;
    border-color: ${props => props.theme.border};
    border-width: ${props => (props.theme.border ? '1px' : '0')};
    border-radius: 2px;
    background-color: ${props => props.theme.background};
    font-size: ${props => (props.size ? `${props.size}px` : `inherit`)};
    height: 2em;
    padding: 0 0.75em;
    user-select: none;
    cursor: ${props => (!props.onClick || props.disabled ? 'default' : 'pointer')} !important;
    opacity: ${props => (!props.onClick || props.disabled ? '0.5' : 'initial')};
    transition: background-color 0.3s ease, border 0.3s ease, color 0.3s ease;
    white-space: nowrap;
    align-items: center;
    box-sizing: border-box;

  i[class*="Icon"] {
    color: ${props => props.theme.icon};
  }

  :hover i[class*="Icon"] {
    color: ${props => props.onClick && !props.disabled && `${props.theme.hover.icon} !important`};
  }

  :hover {
    color: ${props => props.onClick && !props.disabled && `${props.theme.hover.text} !important`};
    background-color: ${props => props.onClick && !props.disabled && props.theme.hover.background};
    border-color: ${props => props.onClick && !props.disabled && props.theme.hover.border};
    border-width: ${props => props.onClick && !props.disabled && (props.theme.hover.border ? '1px' : '0')};
`;

function generateButtonTheme(themeName: string) {
    if (ButtonThemesStyles[themeName]) {
        return ButtonThemesStyles[themeName];
    }
    return ButtonThemesStyles['default'];
}

export function generateButtonSize(sizeName: string | undefined) {
    if (sizeName === BUTTON_SIZE_SMALL) return 11;
    if (sizeName === BUTTON_SIZE_MEDIUM) return 13;
    if (sizeName === BUTTON_SIZE_LARGE) return 14;
    return null;
}

interface ProductGroupButtonProps {
    className?: string;
    dataDisplayname?: string;
    disabled?: boolean;
    onClick: () => void;
    size?: (typeof BUTTON_SIZES)[number];
    theme?: (typeof BUTTON_THEMES)[number] | (typeof ICON_BUTTON_THEMES)[number];
    title?: string;
}
export const ProductGroupButton = ({
    disabled = false,
    theme = BUTTON_THEME_DEFAULT,
    ...props
}: PropsWithChildren<ProductGroupButtonProps>) => {
    const buttonSize = generateButtonSize(props.size);
    const buttonTheme = generateButtonTheme(theme);

    let onClickFunc = () => {};
    if (!disabled) {
        onClickFunc = props.onClick;
    }

    return (
        <StButton
            className={props.className}
            data-displayname={props.dataDisplayname || null}
            disabled={disabled}
            onClick={onClickFunc}
            size={buttonSize}
            theme={buttonTheme}
            type="button"
            title={props.title}
        >
            {props.children}
        </StButton>
    );
};
